<template>
    <div class="container--small">
        <div class="uk-width-large uk-container uk-container-center uk-tile">
            <h1 class="uk-text-center">
                SAVE PIC
            </h1>
            <ul uk-tab>
                <li
                    class="uk-active"
                    :class="{'tab__item--active': tab === 1 }"
                    @click="tab = 1"
                ><a href="#">Login</a></li>
                <li
                    class="tab__item"
                    :class="{'tab__item--active': tab === 2 }"
                    @click="tab = 2"
                ><a href="#">Register</a></li>
            </ul>
            <form class="padding-medium uk-border-rounded border-muted uk-background-default uk-box-shadow-small" @submit.prevent="login" v-show="tab === 1">
                <div v-if="loginErrors" class="uk-form-danger">
                    <ul v-if="loginErrors.email">
                        <li v-for="msg in loginErrors.email" :key="msg">{{ msg }}</li>
                    </ul>
                    <ul v-if="loginErrors.password">
                        <li v-for="msg in loginErrors.password" :key="msg">{{ msg }}</li>
                    </ul>
                </div>
                <div class="uk-margin">
                    <label for="login-email" class="uk-form-label">Email</label>
                    <div class="uk-position-relative">
                        <span class="uk-form-icon" uk-icon="icon: mail"></span>
                        <input type="text" class="uk-input" id="login-email" v-model="loginForm.email">
                    </div>
                </div>
                <div class="uk-margin">
                    <label for="login-password" class="uk-form-label">Password</label>
                    <div class="uk-position-relative">
                        <span class="uk-form-icon" uk-icon="icon: lock"></span>
                        <input type="password" class="uk-input" id="login-password" v-model="loginForm.password">
                    </div>
                </div>
                <div class="">
                    <button type="submit" class="uk-width-1-1 uk-button uk-button-primary">{{ button.login }}</button>
                </div>
            </form>

            <form class="padding-medium uk-border-rounded border-muted uk-background-default uk-box-shadow-small" @submit.prevent="register" v-show="tab === 2">
                <div v-if="registerErrors" class="uk-form-danger">
                    <ul v-if="registerErrors.name">
                        <li v-for="msg in registerErrors.name" :key="msg">{{ msg }}</li>
                    </ul>
                    <ul v-if="registerErrors.email">
                        <li v-for="msg in registerErrors.email" :key="msg">{{ msg }}</li>
                    </ul>
                    <ul v-if="registerErrors.password">
                        <li v-for="msg in registerErrors.password" :key="msg">{{ msg }}</li>
                    </ul>
                </div>


                <div class="uk-margin">
                    <label for="username" class="uk-form-label">Name</label>
                    <div class="uk-position-relative">
                        <span class="uk-form-icon" uk-icon="icon: user"></span>
                        <input type="text" class="uk-input" id="username" v-model="registerForm.name">
                    </div>
                </div>
                <div class="uk-margin">
                    <label for="email" class="uk-form-label">Email</label>
                    <div class="uk-position-relative">
                        <span class="uk-form-icon" uk-icon="icon: mail"></span>
                        <input type="text" class="uk-input" id="email" v-model="registerForm.email">
                    </div>
                </div>
                <div class="uk-margin">
                    <label for="password" class="uk-form-label">Password</label>
                    <div class="uk-position-relative">
                        <span class="uk-form-icon" uk-icon="icon: lock"></span>
                        <input type="password" class="uk-input" id="password" v-model="registerForm.password">
                    </div>
                </div>
                <div class="uk-margin">
                    <label for="password-confirmation" class="uk-form-label">Password (confirm)</label>
                    <div class="uk-position-relative">
                        <span class="uk-form-icon" uk-icon="icon: lock"></span>
                        <input type="password" class="uk-input" id="password-confirmation" v-model="registerForm.password_confirmation">
                    </div>
                </div>

                <div class="">
                    <button type="submit" class="uk-width-1-1 uk-button uk-button-primary">{{ button.register }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { getCookieValue } from '../util'
export default {
    data () {
        return {
            tab: 1,
            loginForm: {
                email: '',
                password: ''
            },
            registerForm: {
                name: '',
                email: '',
                password: '',
                password_confirmation: ''
            },
            button: {
                login: '',
                register: ''
            }
        }
    },
    computed: {
        apiStatus () {
            return this.$store.state.auth.apiStatus
        },
        loginErrors () {
            return this.$store.state.auth.loginErrorMessages
        },
        registerErrors () {
            return this.$store.state.auth.registerErrorMessages
        },
        tempRegisterStatus () {
            return this.$store.state.auth.tempRegisterStatus
        },
    },
    methods: {
        async login () {
            this.button.login = '...'
            // authストアのloginアクションを呼び出す
            const login_data = this.loginForm
            login_data['api_token'] = getCookieValue('token')
            await this.$store.dispatch('auth/login', login_data)

            if (this.apiStatus) {
                // トップページに移動する
                // routerを使用して遷移するとauthエラーが起きるのでlocation.hrefで対応
                location.href = '/'
                // this.$router.push('/')
            }

            this.setButtonText()
        },
        async register () {
            this.button.register = '...'
            // authストアのregisterアクションを呼び出す
            await this.$store.dispatch('auth/register', this.registerForm)

            if (this.tempRegisterStatus) {
                // 仮登録完了ページに移動
                this.$router.push('/temp_register')
            }

            this.setButtonText()
        },
        clearError () {
            this.$store.commit('auth/setLoginErrorMessages', null)
        },
        setButtonText() {
            this.button.login = 'login'
            this.button.register = 'register'
        }
    },
    created () {
        this.clearError()
        this.setButtonText()
    }
}
</script>
